import { Component, OnInit } from '@angular/core';
import {ApprovalService} from '../service/approval.service';
import {ApprovalPending} from '../shared/dto/approval-pending';
import {TokenStorageService} from '../shared/service/token-storage.service';
import {ApplicantRequestService} from '../service/applicant-request.service';
import {ApplicantSearchRequest} from '../model/applicantSearchRequestModel';
import {UserRoleEnum} from '../shared/enums/user-role.enum';
import {PaymentModel} from '../model/payment.model';
import {BlacklistService} from '../shared/service/blacklist.service';
import {MatTableDataSource} from '@angular/material/table';
import {ApprovalModel} from '../shared/dto/approval.model';
import {ReversedBlacklistService} from '../shared/service/reversed-blacklist.service';
import {SuspendService} from '../shared/service/suspend.service';
import {ReversedSuspendService} from '../shared/service/reversed-suspend.service';
import {DispatchPendingModel} from '../shared/dto/dispatch-pending.model';
import {ReversedSuspendBlacklistService} from '../shared/service/reversed-suspend-blacklist.service';
import {SuspendBlacklistService} from '../shared/service/suspend-blacklist.service';

@Component({
  selector: 'app-approval-process',
  templateUrl: './approval-process.component.html',
  styleUrls: ['./approval-process.component.scss']
})
export class ApprovalProcessComponent implements OnInit {

  approvalPending: ApprovalPending = new ApprovalPending();
  applicantSearchRequest: ApplicantSearchRequest = new ApplicantSearchRequest();
  scanPending: DispatchPendingModel = new DispatchPendingModel();
  paymentModel: PaymentModel = new PaymentModel();
  approvalModel: ApprovalModel = new ApprovalModel();
  public userName: string;
  public userType: string;

  public blacklistRouterLinkNew: string = "";
  public blacklistRouterLinkRenew: string = "";
  public blacklistRouterLinkDuplicate: string = "";

  public suspendRouterLinkNew: string = "";
  public suspendRouterLinkRenew: string = "";
  public suspendRouterLinnkDuplicate: string = "";

  public suspendPendingRouterLinkNew: string = "";
  public suspendPendingRouterLinkRenew: string = "";
  public suspendPendingRouterLinkDuplicate: string = "";

  public routerLinkNew: string = "";
  public routerLinkRenew: string = "";
  public routerLinkDuplicate: string = "";
  public routerLinkReturned: string = "";

  public routerLinkNew1: string = "";
  public routerLinkRenew1: string = "";
  public routerLinkDuplicate1: string = "";

  public routerLinkNew2: string = "";
  public routerLinkRenew2: string = "";
  public routerLinkDuplicate2: string = "";

  public returnRouterLink: string = "";
  public returnRenewRouterLink: string = "";
  public returnDuplicateRouterLink: string = "";

  public reversedNewRouterLink: string = "";
  public reversedRenewRouterLink: string = "";
  public reversedDuplicateRouterLink: string = "";

  public reversedPendingNewRouterLink: string = "";
  public reversedPendingRenewRouterLink: string = "";
  public reversedPendingDuplicateRouterLink: string = "";

  public reversedAuthorizedNewRouterLink: string = "";
  public reversedAuthorizedRenewRouterLink: string = "";
  public reversedAuthorizedDuplicateRouterLink: string = "";

  public reveresedReturnNewBlacklistRouterLink: string = "";
  public reversedReturnRenewBlacklistRouterLink: string = "";
  public reversedReturnDuplicateBlacklistRouterLink: string = "";

  public reversedDGReturnNewBlacklistRouterLink: string = "";
  public reversedDGReturnRenewBlacklistRouterLink: string = "";
  public reversedDGReturnDuplicateBlacklistRouterLink: string = "";

  public dgReturnNewRouterLink: string = "";
  public dgReturnRenewRouterLink: string = "";
  public dgReturnDuplicateRouterLink: string = "";

  public reversedSuspendNewRouterLink: string = "";
  public reversedSuspendRenewRouterLink: string = "";
  public reversedSuspendDuplicateRouterLink: string = "";

  public reversedSuspendNewPendingRouterLink: string = "";
  public reversedSuspendRenewPendingRouterLink: string = "";
  public reversedSuspendDuplicatePendingRouterLink: string = "";

  public reversedSuspendNewAuthorizedRouterLink: string = "";
  public reversedSuspendRenewAuthorizedRouterLink: string = "";
  public reversedSuspendDuplicateAuthorizedRouterLink: string = "";

  public reversedSuspendReturnNewRouterLink: string = "";
  public reversedSuspendReturnRenewRouterLink: string = "";
  public reversedSuspendReturnDuplicateRouterLink: string = "";

  public reversedSuspendReturnNewByDGRouterLink: string = "";
  public reversedSuspendReturnRenewByDGRouterLink: string = "";
  public reversedSuspendReturnDuplicateByDGRouterLink: string = "";

  public newSuspendReturnByEXMRouterLink: string = "";
  public renewSuspendReturnByEXMRouterLink: string = "";
  public duplicateSuspendReturnByEXMRouterLink: string = "";

  public newSuspendReturnByDGRouterLink: string = "";
  public renewSuspendReturnByDGRouterLink: string = "";
  public duplicateSuspendReturnByDGRouterLink: string = "";

  public newDispatchByDGRouterLink: string = "";
  public renewDispatchByDGRouterLink: string = "";
  public duplicateDispatchByDGRouterLink: string = "";

  public newReversedSuspendBlacklistSHORouterLink: string = "";
  public renewReversedSuspendBlacklistSHORouterLink: string = "";
  public duplicateReversedSuspendBlacklistSHORouterLink: string = "";

  public newReversedSuspendBlacklistEXMRouterLink: string = "";
  public renewReversedSuspendBlacklistEXMRouterLink: string = "";
  public duplicateReversedSuspendBlacklistEXMRouterLink: string = "";

  public newReversedSuspendBlacklistDGRouterLink: string = "";
  public renewReversedSuspendBlacklistDGRouterLink: string = "";
  public duplicateReversedSuspendBlacklistDGRouterLink: string = "";

  public newReturnReversedSuspendBlacklistSHORouterLink: string = "";
  public renewReturnReversedSuspendBlacklistSHORouterLink: string = "";
  public duplicateReturnReversedSuspendBlacklistSHORouterLink: string = "";

  public newReturnReversedSuspendBlacklistEXMRouterLink: string = "";
  public renewReturnReversedSuspendBlacklistEXMRouterLink: string = "";
  public duplcateReturnReversedSuspendBlacklistEXMRouterLink: string = "";

  public newSuspendBlacklistEXMRouterLink: string = "";
  public renewSuspendBlacklistEXMRouterLink: string = "";
  public duplicateSuspendBlacklistEXMRouterLink: string = "";

  public newSuspendBlacklistDGRouterLink: string = "";
  public renewSuspendBlacklistDGRouterLink: string = "";
  public duplicateSuspendBlacklistDGRouterLink: string = "";

  public newReturnSuspendBlacklistEXMRouterLink: string = "";
  public renewReturnSuspendBlaclistEXMRouterLink: string = "";
  public duplicateReturnSuspendBlacklistEXMRouterLink: string = "";

  public newReturnSuspendBlacklistDGRouterLink: string = "";
  public renewReturnSuspendBlacklistDGRouterLink: string = "";
  public duplicateReturnSuspendBlacklistDGRouterLink: string = "";

  public newReqCounts: number = 0;
  public renewReqCounts: number = 0;
  public dulicateReqCounts: number = 0;
  public returnedReqCounts: number = 0;

  public newBlacklistReqCount: number = 0;
  public renewBlacklistReqCount: number = 0;
  public duplicateBlacklistReqCount: number = 0;
  public blacklistProcessDuplicateCount: number = 0;

  public newReturnBlacklistReqCount: number = 0;
  public renewReturnBlacklistReqCount: number = 0;
  public duplicateReturnBlackliistReqCount: number = 0;

  public newDGReturnBlacklistReqCount: number = 0;
  public renewDGReturnBlacklistReqCount: number = 0;
  public duplicateDGReturnBlacklistReqCount: number = 0;

  public newSuspendRequCount: number = 0;
  public renewSuspendReqCount: number = 0;
  public duplicateSuspendReqCount: number = 0;

  public newPendingSuspendReqCount: number = 0;
  public renewPendingSuspendReqCount: number = 0;
  public duplicatePendingSuspendReqCount: number = 0;

  public reversedNewBlacklistReqCount: number = 0;
  public reversedRenewBlacklistReqCount: number = 0;
  public reversedDuplicateBlacklistReqCount: number = 0;

  public reversedPendingNewBlacklistReqCount: number = 0;
  public reversedPendingRenewBlacklistReqCount: number = 0;
  public reversedPendingDuplicateBlacklistReqCount: number = 0;

  public reversedAuthorizedNewBlacklistReqCount: number = 0;
  public reversedAuthorizedRenewBlacklistReqCount: number = 0;
  public reversedAuthorizedDuplicateBlacklistReqCount: number = 0;

  public reversedReturnNewBlacklistReqCount: number = 0;
  public reversedReturnRenewBlacklistReqCount: number = 0;
  public reversedReturnDuplicateBlacklistReqCount: number = 0;

  public reversedDGReturnNewBlacklistReqCount: number = 0;
  public reversedDGReturnRenewBlacklistReqCount: number = 0;
  public reversedDGReturnDuplicateBlacklistReqCount: number = 0;

  public reversedNewSuspendReqCount: number = 0;
  public reversedRenewSuspendReqCount: number = 0;
  public reversedDuplicateSuspendReqCount: number = 0;

  public reversedPendingNewSuspendReqCount: number = 0;
  public reversedPendingRenewSuspendReqCount: number = 0;
  public reversedPendingDuplicateSuspendReqCount: number = 0;

  public reversedAuthorizedNewSuspendReqCount: number = 0;
  public reversedAuthorizedRenewSuspendReqCount: number = 0;
  public reversedAuthorizedDuplicateSuspendReqCount: number = 0;

  public reversedSuspendReturnNewByEXMReqCount: number = 0;
  public reversedSuspendReturnRenewByEXMReqCount: number = 0;
  public reversedSuspendReturnDuplicateByEXMReqCount: number = 0;

  public reversedSuspendReturnNewByDGReqCount: number = 0;
  public reversedSuspendReturnRenewBYDGReqCount: number = 0;
  public reveresedSuspendReturnDuplicateByDGReqCount: number = 0;

  public newSuspendReturnByEXMReqCount: number = 0;
  public renewSuspendReturnByEXMReqCount: number = 0;
  public duplicateSuspendReturnByEXMReqCount: number = 0;

  public newSuspendReturnByDGReqCount: number = 0;
  public renewSuspendReturnByDGReqCount: number = 0;
  public duplicateSuspendReturnByReqCount: number = 0;

  public newDipatchSCOReqCount: number = 0;
  public renewDispatchSCOReqCount: number = 0;
  public duplicateDispatchSCOReqCount: number = 0;

  public newDispatchDGReqCount: number = 0;
  public renewDispatchDGReqCount: number = 0;
  public duplicateDispatchDGReqCount: number = 0;

  public newReversedSuspendBlacklistSHOReqCount: number = 0;
  public renewReversedSuspendBlacklistSHOReqCount: number = 0;
  public duplicateReversedSuspendBlacklistSHOReqCount: number = 0;

  public newReversedSuspendBlacklistEXMReqCount: number = 0;
  public renewReversedSuspendBlacklistEXMReqCount: number = 0;
  public duplicateReversedSuspendBlacklistEXMReqCount: number = 0;

  public newReversedSuspendBlacklistDGReqCount: number = 0;
  public renewReversedSuspendBlacklistDGReqCount: number = 0;
  public duplicateReversedSuspendBlacklistDGReqCount: number = 0;

  public newReturnReversedSuspendBlacklistSHOReqCount: number = 0;
  public renewReturnReversedSuspendBlacklistSHOReqCount: number = 0;
  public duplicateReturnReversedSuspendBlacklistSHOReqCount: number = 0;

  public newReturnReversedSuspendBlacklistEXMReqCount: number = 0;
  public renewReturnReversedSuspendBlacklistEXMReqCount: number = 0;
  public duplicateReturnReversedSuspendBlacklistEXMReqCount: number = 0;

  public newSuspendBlacklistEXMReqCount: number = 0;
  public renewSuspendBlacklistEXMReqCount: number = 0;
  public duplicateSuspendBlacklistEXMReqCount: number = 0;

  public newSuspendBlacklistDGReqCount: number = 0;
  public renewSuspendBlacklistDGReqCount: number = 0;
  public duplicateSuspendBlacklistDGReqCounnt: number = 0;

  public newReturnSuspendBlacklistSHOReqCount: number = 0;
  public renewReturnSuspendBlacklistSHOReqCount: number = 0;
  public duplicateSuspendBlacklistSHOReqCount: number = 0;

  public newReturnSuspendBlacklistEXMReqCount: number = 0;
  public renewReturnSuspendBlacklistEXMReqCount: number = 0;
  public duplicateReturnSuspendBlacklistEXMReqCount: number = 0;

  public newBlckListDgApp: number = 0;

  public showApprovalProcess: boolean = false;
  public showDispatchProcess: boolean = false;
  public showDGDispatchProcess:boolean = false;
  public paymentProcess: boolean = false;
  public blacklistProcess: boolean = false;
  public pendingBlacklistProcess: boolean = false;
  public authorizedBlacklistProcess: boolean = false;
  public suspendProcess: boolean = false;
  public authorizedSuspendProcess: boolean = false;
  public reverseBlacklistProcess: boolean = false;
  public reversedBlacklistProcessVerification: boolean = false;
  public reveresedBlacklistProcessAuthorization: boolean = false;
  public reversedReturnBlacklistProcess: boolean = false;
  public reversedDGReturnBlacklistProcess: boolean = false;
  public reverseSuspendProcess: boolean = false;
  public reversedSuspendPendingProcess: boolean = false;
  public reversedSuspendAuthorizedProcess: boolean = false;
  public reversedSuspendReturnProcess: boolean = false;
  public reversedSuspendReturnAuthorizedProcess: boolean = false;
  public returnBlacklistProcess: boolean = false;
  public dgReturnBlacklistProcess: boolean = false;
  public returnSuspendProcess: boolean = false;
  public returnSuspendProcessByDG: boolean = false;
  public reversedSuspendBlacklistProcess: boolean = false;
  public reversedSuspendBlacklistVerificationProcess: boolean = false;
  public reversedSuspendBlacklistAuthorizationProcess: boolean = false;
  public returnReversedSuspendBlacklistProcessByEXM: boolean = false;
  public returnReversedSuspendBlacklistProcessByDG: boolean = false;
  public suspendBlacklistPendingProcess: boolean = false;
  public suspendBlacklistAuthorizedProcess: boolean = false;
  public suspendBlacklistReturnEXMProcess: boolean = false;
  public suspendBlacklisReturnDGProcess: boolean = false;
  public newBlckCount: number = 0;

  isLoading1: boolean = false;
  isLoading2: boolean = false;
  isLoading3: boolean = false;
  isLoading4: boolean = false;
  constructor(private approvalService: ApprovalService,
              private blackListService: BlacklistService,
              private suspendService: SuspendService,
              private reversedBlacklistService: ReversedBlacklistService,
              private reversedSuspendService: ReversedSuspendService,
              private applicantService: ApplicantRequestService,
              private tokenStorageService: TokenStorageService,
              private reversedSuspendBalcklistService: ReversedSuspendBlacklistService,
              private suspendBlacklistService: SuspendBlacklistService) {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userType = this.tokenStorageService.getUserObjectToken().userroleCode;
  }

  ngOnInit() {

    this.approvalPending.loginUser = this.userName;

    this.getNewApplicationsRequestCount();
    this.getRenewApplicationsRequestCount();
    this.getDuplicateApplicationsRequestCount();

    this.getReturnedNewApplication();

    this.getRenewBlacklistRequestCount();
    this.getDuplicateBlacklistRequestCount();

    if(this.userType === UserRoleEnum.DEO) {
      this.showApprovalProcess = true;
    }

    if(this.userType === UserRoleEnum.PYO) {
      this.paymentProcess = true;
    }

    if(this.userType === UserRoleEnum.SCO){
      this.showDispatchProcess = true;
      this.getNewScanPendingList();
      this.getRenewScanPendingList();
      this.getDuplicateScanPendingList();
    }

    if(this.userType === UserRoleEnum.SHO) {
      this.getNewBlacklistRequestCount();
      this.getNewReturnBlacklistReqCount();
      this.getRenewReturnBlacklistReqCount();
      this.getDuplicateReturnBlacklistReqCount();

      this.getNewReversedBlacklistReqCount();
      this.getRenewReversedBlacklistReqCount();
      this.getDuplicateReversedBlacklistReqCount();

      this.getNewReversedReturnBlacklistReqCount();
      this.getRenewReversedReturnBlacklistReqCount();
      this.getDuplicateReversedReturnBlacklistReqCount();

      this.getNewReversedSuspendReqCount();
      this.getRenewReversedSuspendReqCount();
      this.getDuplicateReversedSuspendReqCount();

      this.getNewReversedSuspendReturnReqCount();
      this.getRenewReversedSuspendReturnReqCount();
      this.getDuplicateReversedSuspendReturnReqCount();

      this.getNewReturnSuspendByEXM();
      this.getRenewReturnSuspendByEXM();
      this.getDuplicateReturnSuspendByEXM();

      this.getNewReversedSuspendBlacklistSHOReqCount();
      this.getRenewReversedSuspendBlacklistSHOReqCount();
      this.getDuplicateReversedSuspendBlacklistSHOReqCount();

      this.getNewReturnReversedSspendBlacklistSHOReqCount();
      this.getRenewReturnReversedSuspendBlacklistSHOReqCount();
      this.getDuplicateReturnReversedSuspendBlacklistSHOReqCount();

      this.getNewReturnSuspendBlacklistEXMReqCount();
      this.getRenewReturnSuspendBlacklistEXMReqCount();
      this.getDuplicateReturnSuspendBlacklistEXMReqCount();

      this.showApprovalProcess = true;
      this.blacklistProcess = true;
      this.returnBlacklistProcess = true;
      this.returnSuspendProcess = true;
      this.reverseBlacklistProcess = true;
      this.reversedReturnBlacklistProcess = true;
      this.reverseSuspendProcess = true;
      this.reversedSuspendReturnProcess = true;
      this.reversedSuspendBlacklistProcess = true;
      this.returnReversedSuspendBlacklistProcessByEXM = true;
      this.suspendBlacklistReturnEXMProcess = true;
    }

    if(this.userType === UserRoleEnum.EXM) {
      this.getPendingNewBlacklistReqCount();
      this.getPendingRenewBlacklistReqCount();
      this.getPendingDuplicateBlacklistReqCount();

      this.getNewDGReturnBlacklistReqCount();
      this.getRenewDGReturnBlacklistReqCount();
      this.getDuplicateDGReturnBlacklsitReqCount();

      this.getPendingNewReversedBlacklistReqCount();
      this.getPendingRenewReversedBalcklistReqCount();
      this.getPendingDuplicateReversedBlacklistReqCount();

      this.getDGReverseReturnNewBlacklistReqCount();
      this.getDGReverseReturnRenewBlacklistReqCount();
      this.getDGReverseReturnDuplicateBlakclistReqCount();

      this.getNewSuspendRequestCount();
      this.getRenewSuspendRequestCount();
      this.getDuplicateSuspendRequestCount();

      this.getPendingNewReversedSuspendReqCount();
      this.getPendingRenewReversedSuspendReqCount();
      this.getPendingDuplicateReversedSuspendReqCount();

      this.getNewReversedSuspendReturnByDGReqCount();
      this.getRenewReversedSuspendReturnByDGReqCount();
      this.getDuplicateReversedSuspendReturnByDGReqCount();

      this.getNewSuspendReturnByDGReqCount();
      this.getRenewSuspendReturnByDGReqCount();
      this.getDuplicateSuspendReturnByDGReqCount();

      this.getNewReversedSuspendBlacklistEXMReqCount();
      this.getRenewReversedSuspendBlacklistEXMReqCount();
      this.getDuplicateReversedSuspendBlacklistEXMReqCount();

      this.getNewReturnReversedSuspendBlacklistEXMReqCount();
      this.getRenewReturnReversedSuspendBlacklistEXMReqCount();
      this.getDuplicateReturnReversedSuspendBlacklistEXMReqCount();

      this.getNewSuspendBlacklistEXMReqCount();
      this.getRenewSuspendBlacklistEXMReqCount();
      this.getDuplicateSuspendBlacklistEXMReqCount();

      this.getNewReturnSuspendBlacklistDGReqCount();
      this.getRenewReturnSuspendBlacklistDGReqCount();
      this.getDuplicateReturnSuspendBlacklistReqCount();

      this.showApprovalProcess = true;
      this.pendingBlacklistProcess = true;
      this.dgReturnBlacklistProcess = true;
      this.reversedDGReturnBlacklistProcess = true;
      this.returnSuspendProcessByDG = true;
      this.suspendProcess = true;
      this.reversedBlacklistProcessVerification = true;
      this.reversedSuspendPendingProcess = true;
      this.reversedSuspendReturnAuthorizedProcess = true;
      this.reversedSuspendBlacklistVerificationProcess = true;
      this.returnReversedSuspendBlacklistProcessByDG = true;
      this.suspendBlacklistPendingProcess = true;
    }

    if(this.userType === UserRoleEnum.DG) {
      this.getAuthorizedNewBlacklistReqCount();
      this.getAuthorizedRenewBlacklistReqCount();
      this.getAuthorizedDuplicateBlacklistReqCount();

      this.getAuthorizedNewReversedBlacklistReqCount();
      this.getAuthorizedRenewReversedBlacklistReqCount();
      this.getAuthorizedDuplicateReversedBlacklistReqCount();

      this.getAuthorizedNewSuspendReqCount();
      this.getAuthorizedRenewSuspendReqCount();
      this.getAuthorizedDuplicateSuspendReqCount();

      this.getAuthorizedNewReversedSuspendReqCount();
      this.getAuthorizedRenewReversedSuspendReqCount();
      this.getAuthorizedDuplicateReversedSuspendReqCount();

      this.getNewDispatchDGReqCount();
      this.getRenewDispatchDGReqCount();
      this.getDuplicateDispatchDGReqCount();

      this.getNewReversedSuspendBlacklistDGReqCount();
      this.getRenewReversedSuspendBlacklistDGReqCount();
      this.getDuplicateReversedSuspendBlacklistDGReqCount();

      this.getNewSuspendBlacklistDGReqCount();
      this.getRenewSuspendBlacklistDGReqCount();
      this.getDuplicateSuspendBlacklistDGReqCount();

      this.showApprovalProcess = true;
      this.authorizedBlacklistProcess = true;
      this.authorizedSuspendProcess = true;
      this.reveresedBlacklistProcessAuthorization = true;
      this.reversedSuspendAuthorizedProcess = true;
      this.showDGDispatchProcess = true;
      this.reversedSuspendBlacklistAuthorizationProcess = true;
      this.suspendBlacklistAuthorizedProcess = true;
      this.suspendBlacklisReturnDGProcess = true;
    }
  }

  getNewApplicationsRequestCount() {
    this.isLoading1 = true;
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name =  null;
    this.approvalPending.nic =  null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "New";

    if(this.userType === UserRoleEnum.DEO) {
      this.applicantSearchRequest.userName = this.userName;
      this.applicantSearchRequest.passportNo = null;
      this.applicantSearchRequest.nic = null;
      this.applicantSearchRequest.cocNo = null;
      this.applicantSearchRequest.cdcNo = null;
      this.applicantSearchRequest.type = "New";
      this.routerLinkNew = '/dashboard/approval/'+"New";

      this.applicantService.search(this.applicantSearchRequest).subscribe(
        (result: any) => {
          this.isLoading1 = false;
          this.newReqCounts = result.length;
        }
      )

    }else if(this.userType === UserRoleEnum.PYO) {
      this.routerLinkNew = '/dashboard/payment/' + "New";
      this.paymentModel.appRefNo = null;
      this.paymentModel.name =  null;
      this.paymentModel.nic = null;
      this.paymentModel.cdcNo = null;
      this.paymentModel.applicationType = "New";

      this.applicantService.searchPaymentPendingData(this.paymentModel).subscribe(
        (result: any) => {
          this.newReqCounts = result.length;
          this.isLoading1 = false;
        }
      )

    }else{
      this.routerLinkNew = '/dashboard/approval-pending/'+'New';
      this.approvalService.searchApprovalPendingData(this.approvalPending).subscribe(
        (result: any ) => {
          this.newReqCounts = result.length;
          this.isLoading1 = false;
        }
      );
    }
  }

  getRenewApplicationsRequestCount() {
    this.isLoading2 = true;
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name =  null;
    this.approvalPending.nic =  null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Renew";

    if(this.userType === UserRoleEnum.DEO) {
      this.applicantSearchRequest.userName = this.userName;
      this.applicantSearchRequest.passportNo = null;
      this.applicantSearchRequest.nic = null;
      this.applicantSearchRequest.cocNo = null;
      this.applicantSearchRequest.cdcNo = null;
      this.applicantSearchRequest.type = "Renew";
      this.routerLinkRenew = '/dashboard/approval/'+"Renew";

      this.applicantService.search(this.applicantSearchRequest).subscribe(
        (result: any) => {
          this.renewReqCounts = result.length;
          this.isLoading2 = false;
        }
      )
    }else if(this.userType === UserRoleEnum.PYO) {
      this.routerLinkRenew = '/dashboard/payment/' + "Renew";
      this.paymentModel.appRefNo = null;
      this.paymentModel.name =  null;
      this.paymentModel.nic = null;
      this.paymentModel.cdcNo = null;
      this.paymentModel.applicationType = "Renew";

      this.applicantService.searchPaymentPendingData(this.paymentModel).subscribe(
        (result: any) => {
          this.isLoading2 = false;
          this.renewReqCounts = result.length;
        }
      )
    }else{
      this.routerLinkRenew = '/dashboard/approval-pending/'+'Renew';
      this.approvalService.searchApprovalPendingData(this.approvalPending).subscribe(
        (result: any ) => {
          this.isLoading2 = false;
          this.renewReqCounts = result.length;
        }
      );
    }
  }

  getDuplicateApplicationsRequestCount() {
    this.isLoading3 = true;
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name =  null;
    this.approvalPending.nic =  null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Duplicate";

    if(this.userType === UserRoleEnum.DEO) {
      this.applicantSearchRequest.userName = this.userName;
      this.applicantSearchRequest.passportNo = null;
      this.applicantSearchRequest.nic = null;
      this.applicantSearchRequest.cocNo = null;
      this.applicantSearchRequest.cdcNo = null;
      this.applicantSearchRequest.type = "Duplicate";
      this.routerLinkDuplicate = '/dashboard/approval/' + "Duplicate";

      this.applicantService.search(this.applicantSearchRequest).subscribe(
        (result: any) => {
          this.isLoading3 = false;
          this.dulicateReqCounts = result.length;
        }
      )
    }else if(this.userType === UserRoleEnum.PYO) {
      this.routerLinkDuplicate = '/dashboard/payment/' + "Duplicate";
      this.paymentModel.appRefNo = null;
      this.paymentModel.name =  null;
      this.paymentModel.nic = null;
      this.paymentModel.cdcNo = null;
      this.paymentModel.applicationType = "Duplicate";

      this.applicantService.searchPaymentPendingData(this.paymentModel).subscribe(
        (result: any) => {
          this.dulicateReqCounts = result.length;
          this.isLoading3 = false;
        }
      )
    }else{
      this.routerLinkDuplicate = '/dashboard/approval-pending/'+'Duplicate';
      this.approvalService.searchApprovalPendingData(this.approvalPending).subscribe(
        (result: any ) => {
          this.dulicateReqCounts = result.length;
          this.isLoading3 = false;
        }
      );
    }
  }

  getReturnedNewApplication(){
    this.isLoading1 = true;
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name =  null;
    this.approvalPending.nic =  null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Returned";

    if(this.userType === UserRoleEnum.DEO) {
      this.applicantSearchRequest.userName = this.userName;
      this.applicantSearchRequest.passportNo = null;
      this.applicantSearchRequest.nic = null;
      this.applicantSearchRequest.cocNo = null;
      this.applicantSearchRequest.cdcNo = null;
      this.applicantSearchRequest.type = "Returned";
      this.routerLinkReturned = '/dashboard/approval/'+"Returned";

      this.applicantService.search(this.applicantSearchRequest).subscribe(
        (result: any) => {
          this.isLoading1 = false;
          this.returnedReqCounts = result.length;
        }
      )

    }
    else if(this.userType === UserRoleEnum.PYO) {
      this.routerLinkReturned = '/dashboard/payment/' + "Returned";
      this.paymentModel.appRefNo = null;
      this.paymentModel.name =  null;
      this.paymentModel.nic = null;
      this.paymentModel.cdcNo = null;
      this.paymentModel.applicationType = "New";

      this.applicantService.searchPaymentPendingData(this.paymentModel).subscribe(
        (result: any) => {
          this.returnedReqCounts = result.length;
          this.isLoading1 = false;
        }
      )

    }else{
      this.routerLinkReturned = '/dashboard/approval-pending/'+'Returned';
      this.approvalService.searchApprovalPendingData(this.approvalPending).subscribe(
        (result: any ) => {
          this.returnedReqCounts = result.length;
          this.isLoading1 = false;
        }
      );
    }
  }

  setBase64(code: string): string {
    return btoa(code);
  }


  getNewBlacklistRequestCount(){
    this.isLoading4 = true;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "New";
    this.blacklistRouterLinkNew = '/dashboard/blacklist/New';

    this.blackListService.searchRequestData(this.approvalPending).subscribe(
      (result: any ) => {

          console.log(result,"result");

          this.newBlacklistReqCount = result.length;
          this.isLoading4 = false;
      }
    );
  }

  getRenewBlacklistRequestCount(){
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Renew";
    this.blacklistRouterLinkRenew = '/dashboard/blacklist/Renew';

    this.blackListService.searchRequestData(this.approvalPending).subscribe(
      (result: any ) => {
        this.renewBlacklistReqCount = result.length;
      }
    );
  }

  getDuplicateBlacklistRequestCount(){
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Duplicate";
    this.blacklistRouterLinkDuplicate = '/dashboard/blacklist/Duplicate';

    this.blackListService.searchRequestData(this.approvalPending).subscribe(
      (result: any ) => {
        this.duplicateBlacklistReqCount = result.length;
      }
    );
  }

  getNewSuspendRequestCount(){
    this.suspendRouterLinkNew = "/dashboard/suspend-verifications/"+"New";
    this.approvalPending.type = "New";
    this.approvalPending.loginUser = this.userName;
    this.suspendService.getPendingVerificationRequests(this.approvalPending).subscribe(
      (data: ApprovalPending []) => {
          this.newSuspendRequCount = data.length;
      }
    )
  }

  getRenewSuspendRequestCount() {
    this.suspendRouterLinkRenew = "/dashboard/suspend-verifications/"+"Renew";
    this.approvalPending.type = "Renew";
    this.approvalPending.loginUser = this.userName;
    this.suspendService.getPendingVerificationRequests(this.approvalPending).subscribe(
      (data: ApprovalPending []) => {
        this.renewSuspendReqCount = data.length;
      }
    )
  }

  getDuplicateSuspendRequestCount(){
    this.suspendRouterLinnkDuplicate = "/dashboard/suspend-verifications/"+"Duplicate";
    this.approvalPending.type = "Duplicate";
    this.approvalPending.loginUser = this.userName;
    this.suspendService.getPendingVerificationRequests(this.approvalPending).subscribe(
      (data: ApprovalPending []) => {
        this.duplicateSuspendReqCount = data.length;
      }
    )
  }

  getPendingNewBlacklistReqCount() {
    this.routerLinkNew1 = '/dashboard/blacklist-verifications/'+ "New";
    this.approvalModel.type = "New";
    this.approvalModel.userRole = this.userType;
    this.blackListService.getPendingVerificationRequests(this.approvalModel).subscribe(
        (data: ApprovalPending []) => {
          this.newBlacklistReqCount = data.length;
        }
      )
  }

  getPendingRenewBlacklistReqCount() {
    this.routerLinkRenew1 = '/dashboard/blacklist-verifications/'+"Renew";
    this.approvalModel.type = "Renew";
    this.approvalModel.userRole = this.userType;
    this.blackListService.getPendingVerificationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.renewBlacklistReqCount = data.length;
      }
    )
  }

  getPendingDuplicateBlacklistReqCount(){
    this.routerLinkDuplicate1 = '/dashboard/blacklist-verifications/'+"Duplicate";
    this.approvalModel.type = "Duplicate";
    this.approvalModel.userRole = this.userType;
    this.blackListService.getPendingVerificationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.duplicateBlacklistReqCount = data.length;
      }
    )
  }

  getAuthorizedNewBlacklistReqCount(){
    this.routerLinkNew2 = '/dashboard/blacklist-authorizations/'+"New";
    this.approvalModel.type = "New";
    this.approvalModel.userRole = this.userType;
    this.blackListService.getPendingAuthorizationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.newBlckListDgApp = data.length;
      }
    )
  }

  getAuthorizedRenewBlacklistReqCount(){
    this.renewBlacklistReqCount = 0;
    this.routerLinkRenew2 = '/dashboard/blacklist-authorizations/'+"Renew";
    this.approvalModel.type = "Renew";
    this.approvalModel.userRole = this.userType;
    this.blackListService.getPendingAuthorizationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
       this.renewBlacklistReqCount = data.length;
      }
    )
  }

  getAuthorizedDuplicateBlacklistReqCount(){
    this.routerLinkDuplicate2 = '/dashboard/blacklist-authorizations/'+"Duplicate";
    this.approvalModel.type = "Duplicate";
    this.approvalModel.userRole = this.userType;
    this.blackListService.getPendingAuthorizationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.blacklistProcessDuplicateCount = data.length;
      }
    )
  }

  getNewReturnBlacklistReqCount() {
    this.returnRouterLink = '/dashboard/blacklist-return-datas/' + "New";
    this.approvalPending.type = "New";
    this.approvalPending.loginUser = this.userName;
    this.blackListService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
          this.newReturnBlacklistReqCount = result.length;
      }
    )
  }

  getRenewReturnBlacklistReqCount(){
    this.returnRenewRouterLink = '/dashboard/blacklist-return-datas/' + "Renew";
    this.approvalPending.type = "Renew";
    this.approvalPending.loginUser = this.userName;
    this.blackListService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.renewReturnBlacklistReqCount = result.length;
      }
    )
  }

  getDuplicateReturnBlacklistReqCount(){
    this.returnDuplicateRouterLink = '/dashboard/blacklist-return-datas/' + "Duplicate";
    this.approvalPending.type = "Duplicate";
    this.approvalPending.loginUser = this.userName;
    this.blackListService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.duplicateReturnBlackliistReqCount = result.length;
      }
    )
  }

  getNewDGReturnBlacklistReqCount() {
    this.dgReturnNewRouterLink = '/dashboard/return-request-data/'+"New";
    this.approvalPending.type = "New";
    this.approvalPending.loginUser = this.userName;
    this.blackListService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.newDGReturnBlacklistReqCount = result.length;
      }
    )
  }

  getRenewDGReturnBlacklistReqCount() {
    this.dgReturnRenewRouterLink = '/dashboard/return-request-data/'+"Renew";
    this.approvalPending.type = "Renew";
    this.approvalPending.loginUser = this.userName;
    this.blackListService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.renewDGReturnBlacklistReqCount = result.length;
      }
    )
  }

  getDuplicateDGReturnBlacklsitReqCount(){
    this.dgReturnDuplicateRouterLink = '/dashboard/return-request-data/'+"Duplicate";
    this.approvalPending.type = "Duplicate";
    this.approvalPending.loginUser = this.userName;
    this.blackListService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.duplicateDGReturnBlacklistReqCount = result.length;
      }
    )
  }

  getNewReversedBlacklistReqCount(){
    this.reversedNewRouterLink = '/dashboard/reversed-blacklist/' + "New";
    this.approvalPending.type = "New";
    this.approvalPending.loginUser = this.userName;
    this.reversedBlacklistService.getAllRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedNewBlacklistReqCount = result.length;
      }
    )

  }

  getRenewReversedBlacklistReqCount() {
    this.reversedRenewRouterLink = '/dashboard/reversed-blacklist/' + "Renew";
    this.approvalPending.type = "Renew";
    this.approvalPending.loginUser = this.userName;
    this.reversedBlacklistService.getAllRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedRenewBlacklistReqCount = result.length;
      }
    )
  }

  getDuplicateReversedBlacklistReqCount() {
    this.reversedDuplicateRouterLink = '/dashboard/reversed-blacklist/' + "Duplicate";
    this.approvalPending.type = "Duplicate";
    this.approvalPending.loginUser = this.userName;
    this.reversedBlacklistService.getAllRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedDuplicateBlacklistReqCount = result.length;
      }
    )
  }

  getPendingNewReversedBlacklistReqCount() {
    this.approvalModel.type = "New";
    this.approvalModel.userRole = this.userType;
    this.reversedPendingNewRouterLink = '/dashboard/reversed-blacklist-verifications/'+"New";
    this.reversedBlacklistService.getPendingVerificationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.reversedPendingNewBlacklistReqCount = data.length;
      }
    )
  }

  getPendingRenewReversedBalcklistReqCount() {
    this.approvalModel.type = "Renew";
    this.reversedPendingRenewRouterLink = '/dashboard/reversed-blacklist-verifications/'+"Renew";
    this.reversedBlacklistService.getPendingVerificationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.reversedPendingRenewBlacklistReqCount = data.length;
      }
    )
  }

  getPendingDuplicateReversedBlacklistReqCount() {
    this.approvalModel.type = "Duplicate";
    this.reversedPendingDuplicateRouterLink = '/dashboard/reversed-blacklist-verifications/'+"Duplicate";
    this.reversedBlacklistService.getPendingVerificationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.reversedPendingDuplicateBlacklistReqCount = data.length;
      }
    )
  }

  getAuthorizedNewReversedBlacklistReqCount(){
    this.approvalModel.type = "New";
    this.reversedAuthorizedNewRouterLink = "/dashboard/reversed-blacklist-authorizations/"+"New";
    this.approvalModel.userRole = this.userType;
    this.reversedBlacklistService.getPendingAuthorizationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
          this.reversedAuthorizedNewBlacklistReqCount = data.length;
      }
    )
  }

  getAuthorizedRenewReversedBlacklistReqCount(){
    this.approvalModel.type = "Renew";
    this.reversedAuthorizedRenewRouterLink = "/dashboard/reversed-blacklist-authorizations/"+"Renew";
    this.approvalModel.userRole = this.userType;
    this.reversedBlacklistService.getPendingAuthorizationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
          this.reversedAuthorizedRenewBlacklistReqCount = data.length;
      }
    )
  }

  getAuthorizedDuplicateReversedBlacklistReqCount(){
    this.approvalModel.type = "Duplicate";
    this.reversedAuthorizedDuplicateRouterLink = "/dashboard/reversed-blacklist-authorizations/"+"Duplicate";
    this.approvalModel.userRole = this.userType;
    this.reversedBlacklistService.getPendingAuthorizationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.reversedAuthorizedDuplicateBlacklistReqCount = data.length;
      }
    )
  }

  getNewReversedReturnBlacklistReqCount(){
    this.approvalPending.type = "New";
    this.reveresedReturnNewBlacklistRouterLink = "/dashboard/reversed-blacklist-return-datas/"+"New";
    this.reversedBlacklistService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedReturnNewBlacklistReqCount = result.length;
      }
    )
  }

  getRenewReversedReturnBlacklistReqCount(){
    this.approvalPending.type = "Renew";
    this.reversedReturnRenewBlacklistRouterLink = "/dashboard/reversed-blacklist-return-datas/"+"Renew";
    this.reversedBlacklistService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedReturnRenewBlacklistReqCount = result.length;
      }
    )
  }

  getDuplicateReversedReturnBlacklistReqCount(){
    this.approvalPending.type = "Duplicate";
    this.reversedReturnDuplicateBlacklistRouterLink = "/dashboard/reversed-blacklist-return-datas/"+"Duplicate";
    this.reversedBlacklistService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedReturnDuplicateBlacklistReqCount = result.length;
      }
    )
  }

  getDGReverseReturnNewBlacklistReqCount(){
    this.approvalPending.type = "New";
    this.reversedDGReturnNewBlacklistRouterLink  = "/dashboard/reversed-return-request-data/"+"New";
    this.reversedBlacklistService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedDGReturnNewBlacklistReqCount = result.length;
      }
    )
  }

  getDGReverseReturnRenewBlacklistReqCount(){
    this.approvalPending.type = "Renew";
    this.reversedDGReturnRenewBlacklistRouterLink = "/dashboard/reversed-return-request-data/"+"Renew";
    this.reversedBlacklistService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedDGReturnRenewBlacklistReqCount = result.length;
      }
    )
  }

  getDGReverseReturnDuplicateBlakclistReqCount(){
    this.approvalPending.type = "Duplicate";
    this.reversedDGReturnDuplicateBlacklistRouterLink = "/dashboard/reversed-return-request-data/"+"Duplicate";
    this.reversedBlacklistService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
          this.reversedDGReturnDuplicateBlacklistReqCount = result.length;
      }
    )
  }

  getAuthorizedNewSuspendReqCount(){
    this.approvalPending.type = "New";
    this.suspendPendingRouterLinkNew = "/dashboard/suspend-authorizations/"+"New";
    this.suspendService.getPendingAuthorizationRequests(this.approvalPending).subscribe(
      (data: ApprovalPending []) => {
        this.newPendingSuspendReqCount = data.length;
       }
    )
  }

  getAuthorizedRenewSuspendReqCount(){
    this.suspendPendingRouterLinkRenew = "/dashboard/suspend-authorizations/"+"Renew";
    this.approvalPending.type = "Renew";
    this.suspendService.getPendingAuthorizationRequests(this.approvalPending).subscribe(
      (data: ApprovalPending []) => {
        this.renewPendingSuspendReqCount = data.length;
      }
    )
  }

  getAuthorizedDuplicateSuspendReqCount(){
    this.suspendPendingRouterLinkDuplicate = "/dashboard/suspend-authorizations/"+"Duplicate";
    this.approvalPending.type = "Duplicate";
    this.suspendService.getPendingAuthorizationRequests(this.approvalPending).subscribe(
      (data: ApprovalPending []) => {
        this.duplicatePendingSuspendReqCount = data.length;
      }
    )
  }

  getNewReversedSuspendReqCount(){
    this.reversedSuspendNewRouterLink = "/dashboard/reversed-suspend/"+"New";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "New";
    this.reversedSuspendService.getAllRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedNewSuspendReqCount = result.length;
      }
    )
  }

  getRenewReversedSuspendReqCount(){
    this.reversedSuspendRenewRouterLink = "/dashboard/reversed-suspend/"+"Renew";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Renew";
    this.reversedSuspendService.getAllRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedRenewSuspendReqCount = result.length;
        console.log(this.reversedRenewSuspendReqCount);
      }
    )
  }

  getDuplicateReversedSuspendReqCount(){
    this.reversedSuspendDuplicateRouterLink = "/dashboard/reversed-suspend/"+"Duplicate";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Duplicate";
    this.reversedSuspendService.getAllRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedDuplicateSuspendReqCount = result.length;
      }
    )
  }

  getPendingNewReversedSuspendReqCount(){
    this.reversedSuspendNewPendingRouterLink = "/dashboard/reversed-suspend-verifications/"+"New";
    this.approvalModel.type = "New";
    this.approvalPending.loginUser = this.userName;
    this.reversedSuspendService.getPendingVerificationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.reversedPendingNewSuspendReqCount = data.length;
      }
    )
  }

  getPendingRenewReversedSuspendReqCount(){
    this.reversedSuspendRenewPendingRouterLink = "/dashboard/reversed-suspend-verifications/"+"Renew";
    this.approvalModel.type = "Renew";
    this.approvalPending.loginUser = this.userName;
    this.reversedSuspendService.getPendingVerificationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.reversedPendingRenewSuspendReqCount = data.length;
      }
    )
  }

  getPendingDuplicateReversedSuspendReqCount(){
    this.reversedSuspendDuplicatePendingRouterLink = "/dashboard/reversed-suspend-verifications/"+"Duplicate";
    this.approvalModel.type = "Duplicate";
    this.reversedSuspendService.getPendingVerificationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.reversedPendingDuplicateSuspendReqCount = data.length;
      }
    )
  }

  getAuthorizedNewReversedSuspendReqCount(){
    this.reversedSuspendNewAuthorizedRouterLink = "/dashboard/reversed-suspend-authorizations/"+"New";
    this.approvalModel.type = "New";
    this.approvalModel.userRole = this.userType;
    this.reversedSuspendService.getPendingAuthorizationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.reversedAuthorizedNewSuspendReqCount = data.length;
      }
    )
  }

  getAuthorizedRenewReversedSuspendReqCount(){
    this.approvalModel.type = "Renew";
    this.approvalModel.userRole = this.userType;
    this.reversedSuspendRenewAuthorizedRouterLink = "/dashboard/reversed-suspend-authorizations/"+"Renew";
    this.reversedSuspendService.getPendingAuthorizationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.reversedAuthorizedRenewSuspendReqCount = data.length;
      }
    )
  }

  getAuthorizedDuplicateReversedSuspendReqCount(){
    this.reversedSuspendDuplicateAuthorizedRouterLink = "/dashboard/reversed-suspend-authorizations/"+"Duplicate";
    this.approvalModel.type = "Duplicate";
    this.approvalModel.userRole = this.userType;
    this.reversedSuspendService.getPendingAuthorizationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.reversedAuthorizedDuplicateSuspendReqCount = data.length;
      }
    )
  }

  getNewReversedSuspendReturnReqCount(){
    this.reversedSuspendReturnNewRouterLink = "/dashboard/reversed-suspend-return-datas/"+"New";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "New";
    this.reversedSuspendService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedSuspendReturnNewByEXMReqCount = result.length;
      }
    )
  }

  getRenewReversedSuspendReturnReqCount(){
    this.reversedSuspendReturnRenewRouterLink = "/dashboard/reversed-suspend-return-datas/"+"Renew";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Renew";
    this.reversedSuspendService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedSuspendReturnRenewByEXMReqCount = result.length;
      }
    )
  }

  getDuplicateReversedSuspendReturnReqCount(){
    this.reversedSuspendReturnDuplicateRouterLink = "/dashboard/reversed-suspend-return-datas/"+"Duplicate";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Duplicate";
    this.reversedSuspendService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedSuspendReturnDuplicateByEXMReqCount = result.length;
      }
    )
  }

  getNewReversedSuspendReturnByDGReqCount(){
    this.reversedSuspendReturnNewByDGRouterLink =  "/dashboard/reversed-suspend-return-datas/"+"New";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "New";
    this.reversedSuspendService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
       this.reversedSuspendReturnNewByDGReqCount = result.length;
      }
    )
  }

  getRenewReversedSuspendReturnByDGReqCount(){
    this.reversedSuspendReturnRenewByDGRouterLink =  "/dashboard/reversed-suspend-return-datas/"+"Renew";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Renew";
    this.reversedSuspendService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reversedSuspendReturnRenewBYDGReqCount = result.length;
      }
    )
  }


  getDuplicateReversedSuspendReturnByDGReqCount(){
    this.reversedSuspendReturnDuplicateByDGRouterLink =  "/dashboard/reversed-suspend-return-datas/"+"Duplicate";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Duplicate";
    this.reversedSuspendService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.reveresedSuspendReturnDuplicateByDGReqCount = result.length;
      }
    )
  }

  getNewReturnSuspendByEXM(){
    this.newSuspendReturnByEXMRouterLink = "/dashboard/suspend-return/"+"New";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "New";
    this.suspendService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.newSuspendReturnByEXMReqCount = result.length;
      }
    )
  }

  getRenewReturnSuspendByEXM(){
    this.renewSuspendReturnByEXMRouterLink = "/dashboard/suspend-return/"+"Renew";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Renew";
    this.suspendService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.renewSuspendReturnByEXMReqCount = result.length;
      }
    )
  }

  getDuplicateReturnSuspendByEXM(){
    this.duplicateSuspendReturnByEXMRouterLink = "/dashboard/suspend-return/"+"Duplicate";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Duplicate";
    this.suspendService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.duplicateSuspendReturnByEXMReqCount = result.length;
      }
    )
  }

  getNewSuspendReturnByDGReqCount(){
    this.newSuspendReturnByDGRouterLink = "/dashboard/suspend-return/"+"New";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "New";
    this.suspendService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.newSuspendReturnByDGReqCount = result.length;
      }
    )
  }

  getRenewSuspendReturnByDGReqCount(){
    this.renewSuspendReturnByDGRouterLink = "/dashboard/suspend-return/"+"Renew";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Renew";
    this.suspendService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.renewSuspendReturnByDGReqCount = result.length;
      }
    )
  }

  getDuplicateSuspendReturnByDGReqCount(){
    this.duplicateSuspendReturnByDGRouterLink = "/dashboard/suspend-return/"+"Duplicate";
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Duplicate";
    this.suspendService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.duplicateSuspendReturnByReqCount = result.length;
      }
    )
  }

  getNewScanPendingList() {
    this.scanPending.sidNo = null;
    this.scanPending.cdcNo = null;
    this.scanPending.name = null;
    this.scanPending.nic =  null;
    this.scanPending.loginUser = this.userName;
    this.scanPending.type = "New";

    this.approvalService.searchScanPendingData(this.scanPending).subscribe(
      (result: any ) => {
        this.newDipatchSCOReqCount = result.length;
      }
    );
  }

  getRenewScanPendingList() {
    this.scanPending.sidNo = null;
    this.scanPending.cdcNo = null;
    this.scanPending.name = null;
    this.scanPending.nic =  null;
    this.scanPending.loginUser = this.userName;
    this.scanPending.type = "Renew";

    this.approvalService.searchScanPendingData(this.scanPending).subscribe(
      (result: any ) => {
        this.renewDispatchSCOReqCount = result.length;
      }
    );
  }

  getDuplicateScanPendingList() {
    this.scanPending.sidNo = null;
    this.scanPending.cdcNo = null;
    this.scanPending.name = null;
    this.scanPending.nic =  null;
    this.scanPending.loginUser = this.userName;
    this.scanPending.type = "Duplicate";

    this.approvalService.searchScanPendingData(this.scanPending).subscribe(
      (result: any ) => {
        this.duplicateDispatchSCOReqCount = result.length;
      }
    );
  }

  getNewDispatchDGReqCount(){
    this.scanPending.loginUser = this.userName;
    this.scanPending.type = "New";
    this.approvalService.searchDispatchPendingData(this.scanPending).subscribe(
      (result: any ) => {
        this.newDispatchDGReqCount = result.length;
      }
    );
  }

  getRenewDispatchDGReqCount(){
    this.scanPending.loginUser = this.userName;
    this.scanPending.type = "Renew";
    this.approvalService.searchDispatchPendingData(this.scanPending).subscribe(
      (result: any ) => {
        this.renewDispatchDGReqCount = result.length;
      }
    );
  }

  getDuplicateDispatchDGReqCount(){
    this.scanPending.loginUser = this.userName;
    this.scanPending.type = "Duplicate";
    this.approvalService.searchDispatchPendingData(this.scanPending).subscribe(
      (result: any ) => {
        this.duplicateDispatchDGReqCount = result.length;
      }
    );
  }

  getNewReversedSuspendBlacklistSHOReqCount() {
    this.newReversedSuspendBlacklistSHORouterLink = "/dashboard/reversed-suspend-blacklists/"+"New";
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name = null;
    this.approvalPending.nic = null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "New";
    this.reversedSuspendBalcklistService.getAllRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.newReversedSuspendBlacklistSHOReqCount = result.length;
      }
    )
  }

  getRenewReversedSuspendBlacklistSHOReqCount() {
    this.renewReversedSuspendBlacklistSHORouterLink = "/dashboard/reversed-suspend-blacklists/"+"Renew";
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name = null;
    this.approvalPending.nic = null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Renew";
    this.reversedSuspendBalcklistService.getAllRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.renewReversedSuspendBlacklistSHOReqCount = result.length;
      }
    )
  }

  getDuplicateReversedSuspendBlacklistSHOReqCount(){
    this.duplicateReversedSuspendBlacklistSHORouterLink = "/dashboard/reversed-suspend-blacklists/"+"Duplicate";
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name = null;
    this.approvalPending.nic = null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Duplicate";
    this.reversedSuspendBalcklistService.getAllRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.duplicateReversedSuspendBlacklistSHOReqCount = result.length;
      }
    )
  }

  getNewReversedSuspendBlacklistEXMReqCount(){
    this.newReversedSuspendBlacklistEXMRouterLink = "/dashboard/reversed-suspend-blacklist-verifications/"+"New";
    this.approvalModel.type = "New";
    this.reversedSuspendBalcklistService.getPendingVerificationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.newReversedSuspendBlacklistEXMReqCount = data.length;
      }
    )
  }

  getRenewReversedSuspendBlacklistEXMReqCount() {
    this.renewReversedSuspendBlacklistEXMRouterLink = "/dashboard/reversed-suspend-blacklist-verifications/"+"Renew";
    this.approvalModel.type = "Renew";
    this.reversedSuspendBalcklistService.getPendingVerificationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.renewReversedSuspendBlacklistEXMReqCount = data.length;
      }
    )
  }

  getDuplicateReversedSuspendBlacklistEXMReqCount() {
    this.duplicateReversedSuspendBlacklistEXMRouterLink = "/dashboard/reversed-suspend-blacklist-verifications/"+"Duplicate";
    this.approvalModel.type = "Duplicate";
    this.reversedSuspendBalcklistService.getPendingVerificationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.duplicateReversedSuspendBlacklistEXMReqCount = data.length;
      }
    )
  }

  getNewReversedSuspendBlacklistDGReqCount(){
    this.newReversedSuspendBlacklistDGRouterLink = "/dashboard/reversed-suspend-blacklist-authorizations/"+"New";
    this.approvalModel.type = "New";
    this.reversedSuspendBalcklistService.getPendingAuthorizationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.newReversedSuspendBlacklistDGReqCount = data.length;
      }
    )
  }

  getRenewReversedSuspendBlacklistDGReqCount() {
    this.renewReversedSuspendBlacklistDGRouterLink = "/dashboard/reversed-suspend-blacklist-authorizations/"+"Renew";
    this.approvalModel.type = "Renew";
    this.reversedSuspendBalcklistService.getPendingAuthorizationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.renewReversedSuspendBlacklistDGReqCount = data.length;
      }
    )
  }

  getDuplicateReversedSuspendBlacklistDGReqCount(){
    this.duplicateReversedSuspendBlacklistDGRouterLink =  "/dashboard/reversed-suspend-blacklist-authorizations/"+"Duplicate";
    this.approvalModel.type = "Duplicate";
    this.reversedSuspendBalcklistService.getPendingAuthorizationRequests(this.approvalModel).subscribe(
      (data: ApprovalPending []) => {
        this.duplicateReversedSuspendBlacklistDGReqCount = data.length;
      }
    )
  }

  getNewReturnReversedSspendBlacklistSHOReqCount() {
    this.newReturnReversedSuspendBlacklistSHORouterLink = "/dashboard/reversed-suspend-blacklist-return-datas/"+"New";
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name = null;
    this.approvalPending.nic = null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "New";
    this.reversedSuspendBalcklistService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.newReturnReversedSuspendBlacklistSHOReqCount = result.length;
      }
    )
  }

  getRenewReturnReversedSuspendBlacklistSHOReqCount(){
    this.renewReturnReversedSuspendBlacklistSHORouterLink =  "/dashboard/reversed-suspend-blacklist-return-datas/"+"Renew";
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name = null;
    this.approvalPending.nic = null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Renew";
    this.reversedSuspendBalcklistService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.renewReturnReversedSuspendBlacklistSHOReqCount = result.length;
      }
    )
  }

  getDuplicateReturnReversedSuspendBlacklistSHOReqCount(){
    this.duplicateReturnReversedSuspendBlacklistSHORouterLink =  "/dashboard/reversed-suspend-blacklist-return-datas/"+"Duplicate";
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name = null;
    this.approvalPending.nic = null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Duplicate";
    this.reversedSuspendBalcklistService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.duplicateReturnReversedSuspendBlacklistSHOReqCount = result.length;
      }
    )
  }

  getNewReturnReversedSuspendBlacklistEXMReqCount() {
    this.newReturnReversedSuspendBlacklistEXMRouterLink = "/dashboard/reversed-suspend-blacklist-return-datas/"+"New";
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name = null;
    this.approvalPending.nic = null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "New";
    this.reversedSuspendBalcklistService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.newReturnReversedSuspendBlacklistEXMReqCount = result.length;
      }
    )
  }

  getRenewReturnReversedSuspendBlacklistEXMReqCount() {
    this.renewReturnReversedSuspendBlacklistEXMRouterLink = "/dashboard/reversed-suspend-blacklist-return-datas/"+"Renew";
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name = null;
    this.approvalPending.nic = null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Renew";
    this.reversedSuspendBalcklistService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.renewReturnReversedSuspendBlacklistEXMReqCount = result.length;
      }
    )
  }

  getDuplicateReturnReversedSuspendBlacklistEXMReqCount() {
    this.duplcateReturnReversedSuspendBlacklistEXMRouterLink = "/dashboard/reversed-suspend-blacklist-return-datas/"+"Duplicate";
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name = null;
    this.approvalPending.nic = null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Duplicate";
    this.reversedSuspendBalcklistService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.duplicateReturnReversedSuspendBlacklistEXMReqCount = result.length;
      }
    )
  }

  getNewSuspendBlacklistEXMReqCount() {
    this.newSuspendBlacklistEXMRouterLink = "/dashboard/suspend-blacklist-verifications/"+"New";
    this.approvalPending.type = "New";
    this.suspendBlacklistService.getPendingVerificationRequests(this.approvalPending).subscribe(
      (data: ApprovalPending []) => {
        this.newSuspendBlacklistEXMReqCount = data.length;
      }
    )
  }

  getRenewSuspendBlacklistEXMReqCount(){
    this.renewSuspendBlacklistEXMRouterLink = "/dashboard/suspend-blacklist-verifications/"+"ReNew";
    this.approvalPending.type = "Renew";
    this.suspendBlacklistService.getPendingVerificationRequests(this.approvalPending).subscribe(
      (data: ApprovalPending []) => {
        this.renewSuspendBlacklistEXMReqCount = data.length;
      }
    )
  }

  getDuplicateSuspendBlacklistEXMReqCount(){
    this.duplicateSuspendBlacklistEXMRouterLink = "/dashboard/suspend-blacklist-verifications/"+"Duplicate";
    this.approvalPending.type = "Duplicate";
    this.suspendBlacklistService.getPendingVerificationRequests(this.approvalPending).subscribe(
      (data: ApprovalPending []) => {
        this.duplicateSuspendBlacklistEXMReqCount = data.length;
      }
    )
  }

  getNewSuspendBlacklistDGReqCount(){
    this.newSuspendBlacklistDGRouterLink = "/dashboard/suspend-blacklist-authorizations/"+"New";
    this.approvalPending.type = "New";
    this.suspendBlacklistService.getPendingAuthorizationRequests(this.approvalPending).subscribe(
      (data: ApprovalPending []) => {
        this.newSuspendBlacklistDGReqCount = data.length;
      }
    )
  }

  getRenewSuspendBlacklistDGReqCount(){
    this.renewSuspendBlacklistDGRouterLink = "/dashboard/suspend-blacklist-authorizations/"+"Renew";
    this.approvalPending.type = "Renew";
    this.suspendBlacklistService.getPendingAuthorizationRequests(this.approvalPending).subscribe(
      (data: ApprovalPending []) => {
        this.renewSuspendBlacklistDGReqCount = data.length;
      }
    )
  }

  getDuplicateSuspendBlacklistDGReqCount(){
    this.duplicateSuspendBlacklistDGRouterLink = "/dashboard/suspend-blacklist-authorizations/"+"Duplicate";
    this.approvalPending.type = "Duplicate";
    this.suspendBlacklistService.getPendingAuthorizationRequests(this.approvalPending).subscribe(
      (data: ApprovalPending []) => {
        this.duplicateSuspendBlacklistDGReqCounnt = data.length;
      }
    )
  }

  getNewReturnSuspendBlacklistEXMReqCount(){
    this.newReturnSuspendBlacklistEXMRouterLink = "/dashboard/suspend-blacklist-return-data/"+ "New";
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name = null;
    this.approvalPending.nic = null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "New";
    this.suspendBlacklistService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.newReturnSuspendBlacklistSHOReqCount = result.length;
      }
    )
  }

  getRenewReturnSuspendBlacklistEXMReqCount(){
    this.renewReturnSuspendBlaclistEXMRouterLink = "/dashboard/suspend-blacklist-return-data/"+ "Renew";
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name = null;
    this.approvalPending.nic = null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Renew";
    this.suspendBlacklistService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.renewReturnSuspendBlacklistSHOReqCount = result.length;
      }
    )
  }

  getDuplicateReturnSuspendBlacklistEXMReqCount(){
    this.duplicateReturnSuspendBlacklistEXMRouterLink = "/dashboard/suspend-blacklist-return-data/"+ "Duplicate";
    this.approvalPending.appRefNo = null;
    this.approvalPending.cdcNo = null;
    this.approvalPending.name = null;
    this.approvalPending.nic = null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Duplicate";
    this.suspendBlacklistService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.duplicateSuspendBlacklistSHOReqCount = result.length;
      }
    )
  }

  getNewReturnSuspendBlacklistDGReqCount(){
    this.newReturnSuspendBlacklistDGRouterLink = "/dashboard/suspend-return-request-data/"+ "New";
    this.approvalPending.appRefNo =  null;
    this.approvalPending.cdcNo =  null;
    this.approvalPending.name = null;
    this.approvalPending.nic =  null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "New";
    this.suspendBlacklistService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.newReturnSuspendBlacklistEXMReqCount = result.length;
      }
    )
  }

  getRenewReturnSuspendBlacklistDGReqCount(){
    this.renewReturnSuspendBlacklistDGRouterLink = "/dashboard/suspend-return-request-data/"+ "Renew";
    this.approvalPending.appRefNo =  null;
    this.approvalPending.cdcNo =  null;
    this.approvalPending.name = null;
    this.approvalPending.nic =  null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Renew";
    this.suspendBlacklistService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.renewReturnSuspendBlacklistEXMReqCount = result.length;
      }
    )
  }

  getDuplicateReturnSuspendBlacklistReqCount(){
    this.duplicateReturnSuspendBlacklistDGRouterLink = "/dashboard/suspend-return-request-data/"+ "Duplicate";
    this.approvalPending.appRefNo =  null;
    this.approvalPending.cdcNo =  null;
    this.approvalPending.name = null;
    this.approvalPending.nic =  null;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = "Duplicate";
    this.suspendBlacklistService.getAllDGReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.duplicateReturnSuspendBlacklistEXMReqCount = result.length;
      }
    )
  }
}
